export default "__VITE_ASSET__BOTXgcah__"